module.exports = __webpack_public_path__ + "img/ledd_1400.9ef9e809.jpg";